<template>
    <v-container class="noMargin">
        <v-layout row wrap>
            <v-flex lg12>
				<div class="pageTitle">
					<h2>RFC REPORTS</h2>
				</div>
                <v-btn @click.prevent="fncFilterRfc()" class="elevation-5" color="info"><i class="material-icons">filter_list</i>FILTER / CUSTOMIZE REPORT</v-btn>
				<v-btn @click.prevent="fncReloadRfc" class="elevation-5" color="info"><i class="material-icons reloadButton">refresh</i></v-btn>
              <v-menu offset-y>
                <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-title>
                      <a @click.prevent="fncExportRfc( rfcList )">Export to CSV</a>
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {
        name: 'RfcHeader',
        data () {
            return {
            }
        },
        methods: {
            fncFilterRfc() {
                var modalDetails = { title: 'RFC Report Filter', component: 'modal-filter-rfc', mstate: true, params: {} };
                this.$store.commit({
                    type: 'setModal',
                    details: modalDetails
                });
            },
            fncExportRfc( list ) {
                var rfcHistory = 'RFC Date, RFC No, Credit Note No., SR No., Originator, Customer Name, Customer Company, Delivery/Pickup Address, Status ' + "\n";
                for( var i =0; i<list.length; i++ ) {
                    var rfc = list[i];
                    rfcHistory += rfc.created.substr(0,10) + ",";
                    rfcHistory += rfc.number + ",";
                    rfcHistory += rfc.creditNoteNumber !== undefined ? rfc.creditNoteNumber + ',' : '-' + ",";
                    rfcHistory += rfc.salesReturnNumber !== undefined ? rfc.salesReturnNumber + ',' : '-' + ",";
                    rfcHistory += rfc.originator.fullname.replace(/,/g, " ") + ",";
                    rfcHistory += rfc.customer.fullname.replace(/,/g, " ") + ",";
                    if( rfc.customer.company.name != undefined && rfc.customer.company.name != null ) {
                      rfcHistory += rfc.customer.company.name.replace(/,/g, " ") + ",";
                    } else {
                      rfcHistory += 'N/A' + ",";
                    }
                    rfcHistory += rfc.deliveryAddress.address_display.replace(/,/g, " ") + ",";
                    rfcHistory += rfc.statusDescription.replace(/,/g, " ");
                    rfcHistory += "\n";
                }
                var rfcDownload = document.createElement('a');
                rfcDownload.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(rfcHistory));
                rfcDownload.setAttribute('download', 'rfcs.csv');
                rfcDownload.click();
            },
            fncReloadRfc() {
              this.$store.dispatch({
                type: 'fncPopulateRfcList',
                reload: true
              })
            }
        },
        computed: {
            ...mapGetters([
                'objAuthorize',
                'rfcList'
            ])
        },
        beforeMount() {
            this.$store.dispatch('fncPopulateRfcList');
        }
    }
</script>

<style scoped>
    @import '../../shared/assets/css/shared.css'
</style>
